import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=2b3b198c&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b3b198c')) {
      api.createRecord('2b3b198c', component.options)
    } else {
      api.reload('2b3b198c', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=2b3b198c&", function () {
      api.rerender('2b3b198c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qZvWAsjmm08N/JS/comp/ImgFallback.vue"
export default component.exports